import { z } from 'zod';
import { AccountTypeSchema } from './coa.js';
import { MoneySchema } from './common.js';
import { AccountNatureSchema } from './ledger.js';
const DecimalLike = z.union([MoneySchema, z.coerce.number()]);
export const TrialBalanceRowSchema = z.object({
    accountCode: z.string(),
    accountName: z.string(),
    type: AccountTypeSchema,
    nature: AccountNatureSchema,
    // Movement (sum of all postings in range) — NOT a signed balance.
    debit: DecimalLike,
    credit: DecimalLike,
    // Signed per nature (Dr-positive for ASSET/EXPENSE, Cr-positive otherwise).
    // The report renders this as a single "balance" column with a side hint.
    balance: DecimalLike,
});
export const TrialBalanceResponseSchema = z.object({
    asOfDate: z.coerce.date(),
    // Period label (e.g. '202605') when the period filter was used; null when
    // queried by an explicit date range.
    periodLabel: z.string().nullable(),
    rows: z.array(TrialBalanceRowSchema),
    totals: z.object({
        debit: DecimalLike,
        credit: DecimalLike,
        // Sanity check: true iff total Dr === total Cr. Any FALSE here is a real
        // accounting bug (Dr=Cr is enforced at JV-create time; a false here means
        // data drift somewhere).
        balanced: z.boolean(),
    }),
});
export const TrialBalanceQuerySchema = z.object({
    period: z
        .string()
        .regex(/^\d{6}$/)
        .optional(),
    dateFrom: z.iso.date().optional(),
    dateTo: z.iso.date().optional(),
});
//# sourceMappingURL=trial-balance.js.map